import React, { useState, useEffect } from 'react';
import { Breadcrumb, Col, Form, Row } from 'react-bootstrap';
import SecBTN from '../../UI/SecBTN';
import Graybg from '../../UI/Graybg';
import userService from '../../app/services/user.service';
import DataTable from './DataTable/Table';

const BulkQuestionTranslation = () => {
  const user_id = JSON.parse(localStorage.getItem("user"))?.data?.user?.user_id;

  const [selectedFile, setSelectedFile] = useState(null);
  const [dataList, setDataList] = useState([]);
  const [isUploading, setIsUploading] = useState(false);

  // API call when page loads
  useEffect(() => {
    if (!user_id) return;

    const body ={
      user_id: user_id
    }

    userService.bulkQuestionTranslationUploadUser(body)
      .then((res) => {
        console.log("Initial API data", res.task_log);
        setDataList(res.task_log || []);
      })
      .catch((err) => {
        console.error("Initial API error", err);
      });
  }, [user_id]);

  const downloadFile = () => {
    fetch(window.location.origin + "/files/bulkquestranslates.xlsx")
      .then((response) => response.blob())
      .then((blob) => {
        const fileURL = window.URL.createObjectURL(blob);
        const alink = document.createElement("a");
        alink.href = fileURL;
        alink.download = "bulkquestranslates.xlsx";
        alink.click();
      });
  };

  const handleFileChange = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const HandleTranslationUpload = () => {
    if (!selectedFile) {
      alert("Please select a file to upload.");
      return;
    }

    setIsUploading(true);
    const formData = new FormData();
    formData.append("pr_data_file", selectedFile);
    formData.append("user_id", user_id);

    userService.bulkQuestionTranslationUpload(formData)
      .then((res) => {
        console.log("Upload success", res);
        // Handle both possible response structures (task_list or task_log)
        const updatedData = res.task_list || res.task_log || [];
        setDataList(updatedData);
        
        // Clear the file input
        setSelectedFile(null);
        // Reset file input element
        const fileInput = document.querySelector('input[type="file"]');
        if (fileInput) {
          fileInput.value = '';
        }
        
        alert("File uploaded successfully!");
      })
      .catch((err) => {
        console.error("Upload error", err);
        alert("Failed to upload the file.");
      })
      .finally(() => {
        setIsUploading(false);
      });
  };

  return (
    <div className="section">
      <h4>Bulk Question Translation</h4>

      <Breadcrumb>
        <Breadcrumb.Item active>Bulk Question Translation</Breadcrumb.Item>
      </Breadcrumb>

      <Graybg>
        <Row>
          <Col lg={6} md={6} sm={12} className="mb-3">
            <h5 className="mb-3">Upload Question Translations</h5>

            <Form.Group controlId="formFile" className="mb-3">
              <Form.Label>Upload here:</Form.Label>
              <Form.Control type="file" onChange={handleFileChange} />

              {/* Note Section */}
              <div
                style={{
                  background: "#fff3cd",
                  border: "1px solid #ffeeba",
                  padding: "10px",
                  borderRadius: "6px",
                  marginTop: "10px",
                  fontSize: "13px"
                }}
              >
                <strong>Note: </strong>In upload excel file, Set <code>is_trans_solution_only</code> to <b>1</b> to
                translate only the solution and hint for that QID, and <b>0</b> to translate
                the full question content.
              </div>
            </Form.Group>

            <SecBTN 
              className="sec-btn1" 
              onClick={HandleTranslationUpload}
              disabled={isUploading}
            >
              {isUploading ? "Uploading..." : "Upload"}
            </SecBTN>
          </Col>

          <Col lg={6} md={6} sm={12}>
            <SecBTN className="sec-btn1" onClick={downloadFile}>
              <i className="fa fa-download"></i> Sample File
            </SecBTN>
          </Col>
        </Row>
      </Graybg>

      <DataTable
        data={dataList}
        updateHandler={""}
        activationHandler={""}
      />
    </div>
  );
};

export default BulkQuestionTranslation;